import styled from 'styled-components/macro';
import { background } from '../../../../../../assets/Base64Image';

export const BackgroundImage = styled.div`
  background-image: url(${background});
  background-position: right center;
  background-size: 60%;
  background-repeat: no-repeat;
  background-attachment: fixed;
  height: 100vh;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Button = styled.button`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: none;
  white-space: nowrap;
  background: transparent;
  -webkit-tap-highlight-color: transparent;

    &:disabled {
      pointer-events: none;
    }

    &:active {
      transform: scale(0.95);
      -webkit-tap-highlight-color: transparent;
    }

    &:focus {
      -webkit-tap-highlight-color: transparent;
    }
`;
